import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const RestoreQuotesButtonStyled = styled(Button)`
  color: ${colors.red[600]};
  text-transform: uppercase;
`;

export const DiscountPanelStyled = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 3rem 0;
  border-bottom: 1px solid ${colors.neutral[300]};

  @media (width < 850px) {
    flex-wrap: wrap;
    gap: 2rem;
  }
`;
